<template>
    <!-- 投保提示    -->
    <!-- 非会员 -->
    <CvipDialog @close="close()" :title="title" :btnTxt="btnTxt">
        <p class="title-header">尊敬的会员：</p>
        <p class="tipinfo">{{ tipinfo }} </p>
        <p class="applycourse">申请路径:{{ applycourse }}</p>
        <p class="downapp">app下载二维码</p>
        <div class="downloadQRcode"></div>
    </CvipDialog>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import CvipDialog from "./CvipDialog"
    export default {
        name: 'tbtsDialog',
        components: {
            CvipDialog
        },
        props: {
            tipinfo: {
                type: String,
                default (){
                    return 'Hello';
                }
            },
            applycourse: {
                type: String,
                default(){
                    return '申请路径'
                }
            }
        },
        data () {
            return {
                title: '温馨提示',
                btnTxt: '知道了',
                title1: '',
                btnTxt1: '',
                title2: '',
                btnTxt2: '立即体验',
            }
        },
        created () {
            window.clickLog && window.clickLog(`from=pc-cvip-tbts-tanchuang-show-${this.cvipMes.cvipstate}`)
        },
        methods: {
            close () {
                window.clickLog && window.clickLog(`from=pc-cvip-tqtc-tbts-close-${this.cvipMes.cvipstate}`)
                this.$emit("closeDialog")
            }
        },
        computed: mapGetters({
            cvipMes: 'cvipMes',
            rightUsed: 'rightUsed' //4：黄金亮点 5：置顶 10：尊贵标识 11：个人认证 12：求职分析 13：免费刷新 14：求职保障 15：意外保险
        })
    }

</script>


<style lang='scss' scoped>

    .tit{
        margin-top:80px;
    }
    .title-header{
        font-size: 20px;
        font-weight: bold;
        padding-left: 40px;
        
    }
    .tipinfo{
        font-size: 18px;
        padding-left: 75px;
        line-height: 60px;
    }

    .applycourse{
        font-size: 18px;
        font-weight: 900;
        padding-left: 75px;
    }
    .downapp{
        font-size: 18px;
        font-weight: 900;
        padding-left: 40px;
        margin-top: 30px;
    }
    .downloadQRcode{
        margin: 0 auto;
        width: 200px;
        height: 197px;
        background-image: url(//img.58cdn.com.cn/m58/app58/m_static/apiwap/img/qrcode.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .tdtq-bg{
        width: 606px;
        height: 290px;
        margin: 20px auto 0;
        overflow: hidden;
        text-align: center;
    }
    .tdtq-bg-img{
        // width: 606px;
        height: 290px;
    }
    .des-in{
        font-size: 14px;
        color: #AAAAAA;
    }
    .des-use{
        width:100%;
        display:inline-block;
        text-align:center;
    }
    .tit{
        margin: 55px 0 8px;
        font-size: 24px;
        color: #333;
        line-height: 33px;
        text-align:center;
    }
    .tit-names{
        font-size: 24px;
        color: #D4B277;
        line-height: 33px;
    }
</style>


// WEBPACK FOOTER //
// TipDialog.vue?6c7ec353